<template>
  <qx-card title="列表">
    <CarDetailDialog ref="carDetailDialog" />
    <LogRightDialog ref="logRightDialog" busiCode="300000" />
    <section slot="titleRight">
      <qx-permpisions permpisions="1001010301">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="orderBO.ajax?cmd=getDealOrderList"
          :params="fullSearchData"
          bizName="异常审核数据导出"
          bizCode="exp100010"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tableBox" ref="tableBox">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <!-- 订单号码 -->
                <section v-if="scope.column.property === 'orderId'">
                  <span v-if="scope.row.orderType === 1">固定：</span>
                  <span v-else-if="scope.row.orderType === 2">
                    <span v-if="scope.row.sourceFlag === 14">城配：</span>
                    <span v-else>临时：</span>
                  </span>
                  <span v-else>三方：</span>
                  <span class="primary cur" @click="toOrderDetail(scope.row)">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <!-- 订单号码 end -->
                <!-- 运输线路 -->
                <section
                  v-else-if="scope.column.property === 'sourceRegionName'"
                >
                  <span
                    :class="{
                      primary: scope.row.sourceId !== -1,
                      cur: scope.row.sourceId !== -1,
                    }"
                    @click="toLineDetail(scope.row)"
                    >{{
                      `${scope.row.sourceRegionName.replace(
                        '市',
                        ''
                      )}-${scope.row.desRegionName.replace('市', '')}`
                    }}</span
                  >
                </section>
                <!-- 运输线路 end -->
                <!-- 订单收入 -->
                <section v-else-if="scope.column.property === 'costPrice'">
                  {{ scope.row[scope.column.property] / 100 }}
                </section>
                <!-- 订单收入 end -->
                <!-- 车牌号码 -->
                <section v-else-if="scope.column.property === 'plateNumber'">
                  <el-popover placement="top" width="120" trigger="hover">
                    <div style="text-align: left">
                      <p>司机：{{ scope.row.carDriverMan }}</p>
                      <p>手机：{{ scope.row.carDriverPhone }}</p>
                      <p>车型：{{ scope.row.vehicleClassName }}</p>
                    </div>
                    <span class="primary cur" slot="reference">{{
                      scope.row[scope.column.property]
                    }}</span>
                  </el-popover>
                </section>
                <!-- 车牌号码 end -->
                <!-- 车辆类型 -->
                <section v-else-if="scope.column.property === 'licenceType'">
                  <span v-if="scope.row.licenceType === 2">{{
                    scope.row[scope.column.property]
                  }}</span>
                  <span v-else
                    >{{ scope.row.carLenghName }} /
                    {{ scope.row.carStatusName }}</span
                  >
                </section>
                <!-- 车辆类型 end -->
                <!-- 运费 -->
                <section v-else-if="scope.column.property === 'totalFee'">
                  {{ scope.row[scope.column.property] / 100 }}
                </section>
                <!-- 运费 end -->
                <!-- 合同 -->
                <section v-else-if="scope.column.property === 'reciveTypeName'">
                  {{ scope.row.reciveTypeName }}:
                  <span class="primary">{{ scope.row.reciveStateName }}</span>
                </section>
                <!-- 合同 end -->
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="120"
            fixed="right"
          >
            <template slot-scope="scope">
              <section>
                <qx-permpisions permpisions>
                  <span class="primary cur" @click="toHandle(scope.row)"
                    >前往处理</span
                  >
                </qx-permpisions>
                <qx-permpisions permpisions>
                  <span class="primary cur" @click="showLog(scope.row.orderId)"
                    >日志</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操作按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import CarDetailDialog from 'components/carDetailDialog';
import ExportBtn from 'components/exportBtn';
import LogRightDialog from 'components/logRightDialog';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  orderUnusualList,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    CarDetailDialog,
    ExportBtn,
    LogRightDialog,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'orderId',
            label: '订单号码',
            w: 140,
          },
          {
            prop: 'customName',
            label: '客户名称',
          },
          {
            prop: 'sourceName',
            label: '线路名称',
          },
          {
            prop: 'dependTime',
            label: '发车时间',
          },
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'licenceType',
            label: '车辆类型',
          },
          {
            prop: 'vehicleClassName',
            label: '车辆种类',
          },
          {
            prop: 'totalFee',
            label: '运费(元)',
          },
          {
            prop: 'sourceRegionName',
            label: '运输线路',
          },
          {
            prop: 'orgIdName',
            label: '归属部门',
          },
          // 开票服务商
          {
            prop: 'goodsName',
            label: '品名',
          },
          {
            prop: 'loadStateName',
            label: '合同',
          },
          {
            prop: 'reciveTypeName',
            label: '回单',
            w: 200,
          },
          {
            prop: 'orderStateName',
            label: '订单状态',
          },
          {
            prop: 'costPrice',
            label: '订单收入',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: orderUnusualList,
    toOrderDetail (item) {
      this.jump({
        label: `订单详情-${item.orderId}`,
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}`,
        full: true,
      });
    },
    toLineDetail (item) {
      if (item.sourceId === -1) {
        return;
      }
      this.jump({
        label: '线路详情',
        url: `/manage/archives/customer/line/detail?id=${item.sourceId}`,
        full: true,
      });
    },
    showCarDetail (item) {
      this.$refs.carDetailDialog.show(item);
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    toHandle (item) {
      this.jump({
        label: '异常审核处理',
        url: `/manage/operate/order/deal/orderDetailTab?id=${item.orderId}&tar=5&isHandle=true&showBaseInfo=1`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
